export default __webpack_public_path__ + "static/center-fr-b37c1b1e72861abfc450fab5da404434.webp";